import { Redirect, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * AuthRoute - Redirects authenticated users away from auth pages
 * Used for login, register, password reset pages
 *
 * Special case: OAuth linking flow — when ?next= contains /oauth/authorize,
 * the Login component must render even for logged-in users so it can redirect
 * to the backend authorize endpoint with the user's JWT token appended.
 */
const AuthRoute = ({ component: Component, ...rest }) => {
  const user = useSelector((state) => state.user.currentUser);
  const location = useLocation();
  const { from } = location.state || { from: { pathname: "/" } };

  // OAuth flow: let Login handle the redirect back to /oauth/authorize
  const nextUrl = new URLSearchParams(location.search).get("next") || "";
  const isOAuthLinking = nextUrl.includes("/oauth/authorize");

  // In-page auth prompts (e.g. the Reviews "Sign in to write a review" banner)
  // push `/login?redirect=<absolute_path>` — honour that here so users come
  // back to the page they were on, not the homepage.
  const redirectUrl =
    new URLSearchParams(location.search).get("redirect") || "";

  return (
    <Route {...rest}>
      {user && !isOAuthLinking ? (
        // User is logged in — prefer ?redirect=, then location.state.from, then "/"
        <Redirect to={redirectUrl || from} />
      ) : (
        // User is not logged in, OR OAuth linking in progress — show the auth page
        <Component />
      )}
    </Route>
  );
};

export default AuthRoute;
